(() => {
    let menuCategories = document.getElementsByClassName('header__categories-nav');
    let menuCategoriesOptions = menuCategories[0].getElementsByClassName('contents-item');

    let menuHeaderLinkList = menuCategories[0].getElementsByClassName('header__link-list');
    let promoWrapperBrands = menuCategories[0].getElementsByClassName('navigation-promo__wrapper-brands');
    let firstOptionDistance = null;

    let tabsContainerMobile = document.getElementsByClassName('tabs-container-mob');
    let tabsHeaderBrandTabsMobile = document.getElementsByClassName('header__brands-tab--mobile');
    let tabsMobile = tabsContainerMobile[0].getElementsByClassName('tab-item');
    let tabsContainer = document.getElementsByClassName('tabs-container-desk');
    let tabs = tabsContainer[0].getElementsByClassName('tab-item');

    tabsHeaderBrandTabsMobile[0].style.setProperty('--tabs-overflow', 'hidden');

    let megaMenus = document.getElementsByClassName('mega-menu__nav');
    let shopAll = document.getElementsByClassName('mega-menu__shop');

    var window_width = null;
    let location = window.location.href;
    let tabLeftPosition = null;

    let searchvNavbar = document.getElementsByClassName('header__search-container');

    widthActual();

    function getDistance() {
        if (menuCategories) {
            if (menuCategoriesOptions) {
                firstOptionDistance = menuHeaderLinkList[0].offsetLeft;

                if (promoWrapperBrands[0]) if (promoWrapperBrands) promoWrapperBrands[0].style.setProperty('--wrapper-brands-padding-left', `${firstOptionDistance}px`);
            }
        }
    }

    function getLinePosition() {
        if (tabsContainer) {
            if (tabs[0].classList.contains('is-active')) {
                let tab1 = '';
                let tab2 = '';

                if (window_width >= 1150) {
                    tab1 = tabs[0].getBoundingClientRect();
                    tab2 = tabs[1].getBoundingClientRect();

                    tabsContainer[0].style.setProperty('--before-position-right', `${((tab1.left - tab2.width) - 1) * -1}px`);
                    tabsContainer[0].style.setProperty('--width-before', `${(tab2.left + tab2.width) + 2}px`);
                    tabsContainer[0].style.setProperty('--after-position-right', `${tab1.right - tab2.left - 2}px`);

                } else {
                    tab1 = tabsMobile[0].getBoundingClientRect();
                    tab2 = tabsMobile[1].getBoundingClientRect();

                    tabsContainerMobile[0].style.setProperty('--before-position-right-mobile', `${(tab1.left + 2) * -1}px`);
                    tabsContainerMobile[0].style.setProperty('--width-before-mobile', `${tab1.left + 2}px`);

                    if (window_width <= 699) {
                        tabsContainerMobile[0].style.setProperty('--before-position-right-mobile', `${(tab2.x - 2) * -1}px`);
                        tabsContainerMobile[0].style.setProperty('--width-after-mobile', `${tab1.left + 3}px`);
                        tabsContainerMobile[0].style.setProperty('--after-position-right-mobile', `${(tab1.left) * -1}px`);

                    } else {
                        tabsContainerMobile[0].style.setProperty('--before-position-right-mobile', `${(tab2.left - 1) * -1}px`);
                        tabsContainerMobile[0].style.setProperty('--width-after-mobile', `${(tab2.left + 3) * 2}px`);
                        tabsContainerMobile[0].style.setProperty('--after-position-right-mobile', `${((tab2.left) * 2) * -1}px`);
                    }
                }


            } else if (tabs[1].classList.contains('is-active')) {
                let tab1 = '';
                let tab2 = '';

                if (window_width >= 1150) {
                    tab1 = tabs[0].getBoundingClientRect();
                    tab2 = tabs[1].getBoundingClientRect();

                    tabsContainer[0].style.setProperty('--before-position-right', `${(tab1.left - 1) * -1}px`);
                    tabsContainer[0].style.setProperty('--width-before', `${tab1.left + 2}px`);
                    tabsContainer[0].style.setProperty('--after-position-right', `${tab2.width - 2}px`);

                } else {
                    tab1 = tabsMobile[0].getBoundingClientRect();
                    tab2 = tabsMobile[1].getBoundingClientRect();

                    tabsContainerMobile[0].style.setProperty('--before-position-right-mobile', `${(tab2.left) * -1}px`);
                    tabsContainerMobile[0].style.setProperty('--width-before-mobile', `${tab2.left + 3}px`);


                    if (window_width <= 699) {
                        tabsContainerMobile[0].style.setProperty('--width-after-mobile', `${tab1.left + tab1.width}px`);
                        tabsContainerMobile[0].style.setProperty('--after-position-right-mobile', `${(tab1.x - 3) * -1}px`);

                    } else {
                        tabsContainerMobile[0].style.setProperty('--width-after-mobile', `${tab2.right}px`);
                        tabsContainerMobile[0].style.setProperty('--after-position-right-mobile', `${(tab2.right - tab1.width + 3) * -1}px`);
                    }
                }

            } else {
                let tab1 = tabs[0].getBoundingClientRect();
                tabsContainer[0].style.setProperty('--after-position-right', `${tab1.width}px`);
                tabsContainer[0].style.setProperty('--width-before', `${tab1.x}px`);
                tabsContainer[0].style.setProperty('--before-position-right', `${tab1.left * -1}px`);
            }
        }
    }

    function getLogoTabPosition() {
        let tabLogoImage = '';

        return new Promise((resolve, reject) => {
            let logoImagesLogos = '';
            let megamenuBrands = '';
            let megamenuBrandsRect = '';
            let megamenuBrandsMargin = 0;

            if (window_width < 1150) {
                logoImagesLogos = tabsContainerMobile[0].getElementsByClassName('image-logo');
            } else {
                let tabsContainer = document.getElementsByClassName('header__brands-tab--desk');
                logoImagesLogos = tabsContainer[0].getElementsByClassName('image-logo');
            }

            for (let i = 0; i < logoImagesLogos.length; i++) {
                const logoImage = logoImagesLogos[i];

                let diferenceWidthHeight = logoImagesLogos[0].getBoundingClientRect().top + (logoImagesLogos[0].getBoundingClientRect().height - logoImagesLogos[1].getBoundingClientRect().height);

                let elDistanceToTop = logoImagesLogos[1].getBoundingClientRect().top - logoImagesLogos[0].getBoundingClientRect().top;

                if (i == 1) {
                    logoImage.style.setProperty('--margin-top', `${elDistanceToTop}px`);

                    if (widthActual < 1150) {
                        logoImage.style.setProperty('--tab-decor-height', `${logoImagesLogos[0].getBoundingClientRect().height * 1.75}px`);
                    }
                }
            }


            if (!location.includes('decor')) {
                let tab1 = tabs[0].getBoundingClientRect();
                tabLogoImage = tabs[0].getElementsByClassName('tab-link');
                tabLeftPosition = tabLogoImage[0].offsetLeft;

                let calculatedMarginLeft = '';

                megamenuBrands = document.getElementsByClassName('mega-menu-brands-acento');

                if (megamenuBrands.length != 0) {
                    megamenuBrandsRect = megamenuBrands[0].getBoundingClientRect();
                }

                megamenuBrands[0].style.setProperty('--margin-left-megamenu-brands', `${menuCategoriesOptions[0].getBoundingClientRect().left - menuCategoriesOptions[0].getBoundingClientRect().y}px`);

                if (window_width >= 1150 && window_width < 1200) {
                    calculatedMarginLeft = tabLogoImage[0].getBoundingClientRect().x - tabLogoImage[0].getBoundingClientRect().width; //ok

                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft - 20}px`);

                } else if (window_width >= 1200 && window_width < 1600) {
                    calculatedMarginLeft = menuCategoriesOptions[0].getBoundingClientRect().x - menuCategoriesOptions[0].getBoundingClientRect().width; //ok

                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft - 40}px`);

                } else if (window_width >= 1600 && window_width < 1800) {
                    calculatedMarginLeft = 175; //ok

                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft}px`);

                } else {
                    let optionMenuCategoriesOptions = menuCategoriesOptions[0].getBoundingClientRect();

                    calculatedMarginLeft = 175;

                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft}px`);

                    if (megamenuBrands.length != 0) {
                        megamenuBrandsMargin = (menuCategoriesOptions[0].offsetLeft - megamenuBrandsRect.width) - 50;
                        megamenuBrands[0].style.setProperty('--margin-left-megamenu-brands', `${menuCategoriesOptions[0].getBoundingClientRect().left - menuCategoriesOptions[0].getBoundingClientRect().y + 20}px`);
                    }
                }

                let optionMenuCategoriesOptions = menuCategoriesOptions[0].getBoundingClientRect();

                setMenuListPosition(calculatedMarginLeft);
                resolve();

            } else {
                let tab1 = tabs[0].getBoundingClientRect();
                let tab2 = tabs[1].getBoundingClientRect();

                tabLogoImage = tabs[1].getElementsByClassName('tab-link');
                tabLeftPosition = tabLogoImage[0].offsetLeft;
                menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${tab1.width + tabLeftPosition}px`);

                let calculatedMarginLeft = '';

                megamenuBrands = document.getElementsByClassName('mega-menu-brands-decor');
                megamenuBrandsRect = megamenuBrands[0].getBoundingClientRect();

                megamenuBrandsMargin = (menuCategoriesOptions[0].offsetLeft - megamenuBrandsRect.width) - megamenuBrandsRect.width - 50;

                firstOptionDistance = menuHeaderLinkList[0].offsetLeft;
                
                megamenuBrands[0].style.setProperty('--wrapper-brands-padding-left', `${firstOptionDistance}px`);
                
                if (window_width >= 1150 && window_width < 1200) {
                    calculatedMarginLeft = '-30';
                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft}px`);
                    megamenuBrands[0].style.setProperty('--margin-left-megamenu-brands', `0px`);

                    
                } else if (window_width >= 1200 && window_width < 1800) {
                    calculatedMarginLeft = '-25';
                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft}px`);
                } else {
                    let optionMenuCategoriesOptions = menuCategoriesOptions[0].getBoundingClientRect();
                    
                    calculatedMarginLeft = 28;
                    menuHeaderLinkList[0].style.setProperty('--margin-left-link-list', `${calculatedMarginLeft}px`);
                    
                    megamenuBrands[0].style.setProperty('--margin-left-megamenu-brands', `${menuCategoriesOptions[0].getBoundingClientRect().left - menuCategoriesOptions[0].getBoundingClientRect().width}px`);
                }

                setMenuListPosition(calculatedMarginLeft);
                resolve();
            }
        })
    }

    function setMenuListPosition(tabLeftPosition) {
        let widthOriginal = window.innerWidth;

        if (megaMenus.length > 0) {
            for (let i = 0; i < megaMenus.length; i++) {
                const megaMenu = megaMenus[i];
                let computedStyle = null;
                let paddingLeft = null;
                let paddingLeftValue = null;

                if (widthOriginal == window_width) {
                    computedStyle = window.getComputedStyle(megaMenu);
                    paddingLeft = computedStyle.getPropertyValue('padding-left');
                    paddingLeftValue = paddingLeft.replace('px', '');
                    megaMenu.style.setProperty('padding-left', `${tabLeftPosition}px`);

                    if (shopAll.length > 0) {
                        for (let i = 0; i < shopAll.length; i++) {
                            const shop = shopAll[i];
                            shop.style.setProperty('--padding-left-shop-all', `${tabLeftPosition}px`);
                        }
                    }

                } else {
                    computedStyle = window.getComputedStyle(megaMenu);
                    paddingLeft = computedStyle.getPropertyValue('padding-left');
                    paddingLeftValue = paddingLeft.replace('px', '');

                    megaMenu.style.setProperty('padding-left', `${tabLeftPosition}px`);
                }
            }
        }
    }

    function widthActual() {
        return window_width = window.innerWidth;
    }

    document.addEventListener("DOMContentLoaded", (ev) => {
        getLinePosition();

        getLogoTabPosition().then(() => {
            getDistance();
        });
    });

    window.addEventListener("resize", (event) => {
        widthActual();


        getLogoTabPosition().then(() => {
            getLinePosition();
            getDistance();
        });
    });
})()